import React from "react";
import Layout from "../components/organisms/Layout";
import TabsAccordionList from "../components/molecules/TabsAccordionList";
import WrapperFaqs from "../components/atoms/WrapperFaqs";

const faqs = () => {
  return (
    <Layout>
      <WrapperFaqs>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6 text-center">
              <h1>¿Tienes alguna pregunta?</h1>
              <p className="mb-4">
                Por favor revisa las preguntas frecuentes. <br /> Si no
                encuentras tu respuesta, por favor, ponte en contacto con
                nosotros y nuestros Gurús en tranquilidad de guiarán.
              </p>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="card text-center faq-list">
                <TabsAccordionList />
              </div>
            </div>
          </div>
        </div>
      </WrapperFaqs>
    </Layout>
  );
};

export default faqs;
